import {Mapper} from '@s-ui/domain'

export class SeoTechnicalDetailsMetaInformationMapper extends Mapper {
  constructor({config, seoDataValueObjectFactory, seoDataMapper, seoLiteralMapper}) {
    super()

    this._config = config
    this._seoDataValueObjectFactory = seoDataValueObjectFactory
    this._seoDataMapper = seoDataMapper
    this._seoLiteralMapper = seoLiteralMapper
  }

  _parseCanonical = ({url, placeholderValues = {}}) => {
    return Object.keys(placeholderValues).reduce((url, key) => {
      return placeholderValues[key] ? url.replace(`%{${key}}`, placeholderValues[key]) : url
    }, url)
  }

  _parseVersion = ({rawVersion}) => {
    if (!rawVersion) return
    const VERSION_REGEX = /(?<version>^(.*?)cv)/
    const matchedParts = rawVersion.match(VERSION_REGEX)
    const {version = rawVersion} = matchedParts?.groups || {}
    return version
  }

  async map({culture, pageName, params = {}}) {
    const protocol = this._config.get('URL_PROTOCOL')
    const host = this._config.get('HOST_DOMAIN')
    const {technicalDetails: technicalDetailsConfig} = this._config.get('seo')
    const {META_DESCRIPTION, META_ROBOTS, CANONICAL, TITLE} = technicalDetailsConfig[pageName][culture]

    const siteUrl = `${protocol}${host}`

    const {
      bodyType,
      doors,
      fuelType,
      initDate,
      make,
      model,
      vehicleId,
      version: rawVersion,
      versionId,
      year
    } = params || {}

    const placeholderValues = {
      ...(bodyType && {bodyType}),
      ...(doors && {doors}),
      ...(fuelType && {fuelType}),
      ...(initDate && {initDate}),
      ...(make && {make}),
      ...(model && {model}),
      ...(rawVersion && {
        version: this._parseVersion({rawVersion})
      }),
      ...(siteUrl && {siteUrl}),
      ...(vehicleId && {vehicleId}),
      ...(versionId && {versionId}),
      ...(year && {year})
    }

    const parsedTitle = this._seoLiteralMapper
      .setText({text: TITLE})
      .setPlaceholderValues({placeholderValues})
      .setPlaceholderValuesToUpperCase()
      .map()

    const parsedDescription = this._seoLiteralMapper
      .setText({text: META_DESCRIPTION})
      .setPlaceholderValues({placeholderValues})
      .setPlaceholderValuesToUpperCase()
      .map()

    const parsedCanonical = this._parseCanonical({
      url: CANONICAL,
      placeholderValues
    })

    const {links, metas, scripts, title} = this._seoDataMapper
      .title(parsedTitle)
      .description(parsedDescription)
      .robots(META_ROBOTS)
      .canonical(parsedCanonical)
      .setOpenGraphData({
        title: parsedTitle,
        description: parsedDescription,
        url: parsedCanonical
      })
      .setTwitterCardsData()
      .map()

    return this._seoDataValueObjectFactory({
      head: {
        link: links,
        meta: metas,
        scripts,
        title
      }
    })
  }
}
